export default "__VITE_ASSET__Df9YJ1Eg__"